var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image"},[_c('div',{staticClass:"image-inner inner"},[_c('img',{attrs:{"src":_vm.item.image}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }